import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type PostBegin2FASetupResponse = {
  qrCodeUrl: string;
  manualCode: string;
};

export const usePostBegin2FASetup = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostBegin2FASetupResponse) => void;
    onError?: (error: unknown) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async () => {
      const { data } = await client.post<{
        body: PostBegin2FASetupResponse;
      }>(`/auth/2fa/totp/setup`);

      return data.body;
    },
    onSuccess,
    onError,
  });
};
